"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsCurrentDiversityResourcesCached = void 0;
const diversity_1 = require("@completeanatomy/diversity");
const models_1 = require("@completeanatomy/models");
const useIsDiversityResourceCached_1 = require("./useIsDiversityResourceCached");
function useIsCurrentDiversityResourcesCached() {
    const diversityKey = (0, diversity_1.useDiversityKey)();
    const selectedModel = (0, models_1.useSelectedModel)();
    const modelType = selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type;
    return (0, useIsDiversityResourceCached_1.useIsDiversityResourceCached)(diversityKey, modelType);
}
exports.useIsCurrentDiversityResourcesCached = useIsCurrentDiversityResourcesCached;
